import { render, staticRenderFns } from "./EventConference.vue?vue&type=template&id=317f813a&"
import script from "./EventConference.vue?vue&type=script&lang=js&"
export * from "./EventConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports